import { ApiError } from '../../apiError'
import { CustomComponentLibraryWrappedClient } from '../../customComponentLibraryWrappedClient'

export async function ensureLibraryExistsOnTarget(
  libraryId: string,
  originClient: CustomComponentLibraryWrappedClient,
  targetClient: CustomComponentLibraryWrappedClient,
) {
  try {
    await targetClient.customComponentLibrariesLibraryIdGet({
      libraryId,
    })
  } catch (e) {
    if (e instanceof ApiError && e.statusCode === 404) {
      const { data: originLibrary } = await originClient.customComponentLibrariesLibraryIdGet({
        libraryId,
      })
      await targetClient.customComponentLibrariesPost({
        customComponentLibrariesPostRequest: {
          description: originLibrary.description,
          id: originLibrary.id,
          label: originLibrary.label,
          name: originLibrary.name,
        },
      })
    }
  }
}
